<template>
  <div>
    <form-field-input
        label="Label"
        v-model="form.label"
        :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-select
      label="State"
      v-model="form.state"
      :validation-errors="validationErrors.state"
    >
      <option
        v-for="state in states"
        :key="state.value"
        :value="state.value"
      >{{ state.label }}</option>
    </form-field-select>

    <form-field-select
        label="Order"
        v-model="form.order"
        :validation-errors="validationErrors.order"
    >
      <option
        v-for="status in statuses"
        :key="status.id"
        :value="status.order"
      >
        <template v-if="status.order === currentFormOrder">
          Current Position: {{status.label}}
        </template>
        <template v-else-if="status.order > currentFormOrder">
          After {{ status.label }}
        </template>
        <template v-else-if="status.order < currentFormOrder">
          Before {{ status.label }}
        </template>
      </option>
      <option :value="statuses.length + 1">At End</option>
    </form-field-select>

<!--    <template v-if="isActiveState">-->
<!--      <form-field-select-->
<!--          label="Ensure status change by"-->
<!--          v-model="requiresDate"-->
<!--      >-->
<!--        <option :value="false">Setting Acceptable Time</option>-->
<!--        <option :value="true">Requiring Date</option>-->
<!--      </form-field-select>-->

<!--      <form-field-time-in-minutes-->
<!--          label="Acceptable Time"-->
<!--          v-model="form.acceptable_time"-->
<!--          v-show="!requiresDate"-->
<!--          :validation-errors="validationErrors.acceptable_time"-->
<!--      ></form-field-time-in-minutes>-->
<!--    </template>-->

    <template v-if="pipelineViews.length">
      <h4 class="mt-200 mb-50 has-text-weight-semibold">Pipeline Views</h4>
      <label class="label form_field--label">Choose the pipeline view you want this status to be in.</label>

      <form-field
        v-for="(pipelineView, index) in pipelineViews"
        :key="index"
      >
        <b-checkbox
          v-model="form.pipeline_view_ids"
          :key="index"
          :native-value="pipelineView.id"
        >
          {{ pipelineView.label }}
        </b-checkbox>
      </form-field>

      <form-validation-errors
        :validation-errors="validationErrors.pipeline_view_ids"
      ></form-validation-errors>
    </template>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import {ENUMS} from "../services/enums";
import FormValidationErrors from "../components/form/FormValidationErrors";

export default {
  name: "StatusForm",
  components: {FormValidationErrors},
  props: {
    formData: Object,
  },
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      requiresDate: false,
      states: ENUMS.StatusStateEnum,
      validationErrors: {},
      defaultForm: {
        account_id: this.$store.getters.account.id,
        order: this.$store.state.account.statuses.length + 1,
        label: '',
        acceptable_time: 60,
        state: ENUMS.StatusStateEnum.Active.value,
        type: ENUMS.StatusTypeEnum.Standard.value,
        pipeline_view_ids: [],
      },
    }
  },
  created() {
    this.form = (this.formData && (this.formData.id || this.formData.state)) ? this.$utils.clone({...this.defaultForm, ...this.formData}) : this.$utils.clone(this.defaultForm);
    this.requiresDate = this.form.acceptable_time === null;
  },
  computed: {
    statuses() {
      const allStatuses = this.$store.getters['pipeline/statuses'];
      return allStatuses.filter(status => status.state === this.form.state);
    },
    pipelineViews() {
      return this.$store.getters['pipeline/pipelineViews'];
    },
    isActiveState() {
      return this.form.state === ENUMS.StatusStateEnum.Active.value;
    },
    currentFormOrder() {
      if (this.formData && this.formData.order) {
        return this.formData.order;
      }

      return this.$store.state.account.statuses.length + 1;
    }
  },
  methods: {
    validate() {
      let errors = {};

      if (this.requiresDate === false && !this.form.acceptable_time) {
        errors.acceptable_time = ['required'];
      }

      return errors;
    },
    update() {
      if (this.requiresDate) {
        this.form.acceptable_time = null;
      }

      return this.$api.statuses.update(this.form)
      .then((res) => {
        this.$buefy.toast.open({
          message: 'Status was updated',
          type: 'is-success'
        });

            return res;
          });
    },
    create() {
      if (this.requiresDate) {
        this.form.acceptable_time = null;
      }

      return this.$api.statuses.create(this.form)
      .then((res) => {
        this.$buefy.toast.open({
          message: 'Status was created',
          type: 'is-success'
        });

            return res;
          });
    },
    delete() {
      return this.$api.statuses.delete(this.form.id)
      .then((res) => {
        this.$buefy.toast.open({
          message: 'Status was archived',
          type: 'is-success'
        });

            return res;
          });
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
